<template>
  <responsive-drawer-header :color="theme.appBar.other.color" :moduleUnreadCount="unreadCountsByInstance[$route.params.instance]">
    <template v-slot:drawer-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:drawer-subtitle>{{ $t('documents') }}</template>

    <!-- left container -->
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle>
      <div v-if="isLoaded">{{ selectedItemTitle }}</div>
      <div v-else>{{ $t('fahrdienst452.noSelection') }}</div>
    </template>

    <template v-slot:right>
      <!-- right content in case of tour mode -->

      <!-- right content in case of document mode -->
      <div v-if="!xs && isLoaded && displayedDocument" class="d-flex align-center">
        <!-- Toolbar items for document displayed on medium sized devices and up-->
        <acknowledge-button
          v-if="!smAndDown && isToAcknowledge"
          :document="displayedDocument"
          :documentTitle="displayedDocument.title"
          :moduleType="moduleType"
          :color="color"
        ></acknowledge-button>

        <toggle-read-button v-if="!smAndDown && hasReadFeature && !isToAcknowledge" :item="displayedDocument" :color="color"></toggle-read-button>

        <!-- currently not implemented on cockpit side -->
        <!-- <favorite-icon v-if="!xs" :item="displayedDocument" :activeColor="color" :inactiveColor="color"></favorite-icon> -->
      </div>
      <custom-date-picker v-if="!smAndDown" v-model="datePickerDate" :showToday="false" :color="color"></custom-date-picker>
      <date-duty-selection
        ref="dateDutySelection"
        v-if="isLoaded"
        :color="color"
        @onSelectionCompleted="onDateDutySelectionCompleted"
        :instance="instance"
        :instanceFiles="instanceFiles"
        :dutiesAtSelectedDate="dutiesAtSelectedDate"
        :date="datePickerDate"
        :duty="duty"
      >
      </date-duty-selection>

      <div v-if="isLoaded" class="d-flex align-center">
        <v-menu bottom :max-width="400" :small="xs" left transition="slide-y-transition" offset-y close-on-click close-on-content-click>
          <template v-slot:activator="{ on, attrs }">
            <v-btn :color="color" fab class="d-flex trx-15" icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item v-if="mdAndDown && !mx_isLeftDrawerOpen" @click="mx_isLeftDrawerOpen = true">
              <v-list-item-icon>
                <v-icon>mdi-file-document</v-icon>
              </v-list-item-icon>
              <v-list-item-title> {{ $t('fd.displayDocuments') }}</v-list-item-title>
            </v-list-item>

            <toggle-read-button v-if="smAndDown && hasReadFeature" listItem :item="displayedDocument" :color="color"></toggle-read-button>

            <download v-if="features.enableDocumentDownload !== false && !hideDocumentDownload" listItem :downloadUrl="documentUrl" :color="color"></download>

            <!-- favorite currently not implemented on cockpit side -->
            <favorite-icon v-if="!xs" listItem :item="displayedDocument"></favorite-icon>

            <share-button
              listItem
              :file="displayedDocument"
              :moduleBackendId="moduleBackendId"
              :color="color"
              :hideShareButton="hideDocumentShare"
            ></share-button>

            <acknowledge-button
              listItem
              v-if="smAndDown && isToAcknowledge"
              :documentTitle="displayedDocument.title"
              :document="displayedDocument"
              :moduleType="moduleType"
            ></acknowledge-button>
          </v-list>
        </v-menu>
      </div>
    </template>
  </responsive-drawer-header>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import dateUtils from '@/common/dateUtils';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import DateDutySelection from '@/modules/fahrdienst/DateDutySelection.vue';
import Download from '@//components/buttons/Download.vue';
import ShareButton from '@/components/buttons/ShareButton.vue';
import ToggleReadButton from '@/components/buttons/ToggleReadButton.vue';
import FavoriteIcon from '@/components/buttons/FavoriteIcon.vue';
import AcknowledgeButton from '@/components/buttons/AcknowledgeButton.vue';
import acknowledgeService from '@/services/acknowledgeService';
import DB from './storeNonReactive';
import index from './index';
import fahrdienstUtil from './fahrdienstUtil';
import fahrdienstMixin from './fahrdienstMixin';
import { ROUTE_FAHRDIENST_DAY, ROUTE_FAHRDIENST_DUTY } from './routes';
import CustomDatePicker from '../../components/pickers/CustomDatePicker.vue';
import dataUtils from '@/common/dataUtils';

const ROOT = {};

export default {
  name: 'FahrdienstHeader',
  mixins: [common, configMixin, dateTimeMixin, fahrdienstMixin],
  components: {
    FavoriteIcon,
    ResponsiveDrawerHeader,
    DateDutySelection,
    Download,
    ShareButton,
    ToggleReadButton,
    AcknowledgeButton,
    CustomDatePicker,
  },
  mounted() {
    console.debug('created: dutiesAtSelectedDate ', this.dutiesAtSelectedDate);

    if (this.isLoaded) {
      if (this.date) {
        this.datePickerDate = this.date;
      }

      if (!this.duty && !this.displayedDocument) {
        let duty = this.dutiesAtSelectedDate[0];
        let selectedDateYYYYMMDD = dateUtils.formatDateAsYYYYMMDD(this.datePickerDate);
        if (duty && selectedDateYYYYMMDD) {
          console.debug('FahrdienstHeader routing to ROUTE_FAHRDIENST_DUTY');
          this.$router.push({
            name: ROUTE_FAHRDIENST_DUTY,
            params: { instance: duty.inst, dutyId: duty.id, dateYYYYMMDD: selectedDateYYYYMMDD },
          });
        }
        this.$refs['dateDutySelection'].onOpen();
      }
    }
  },

  data() {
    return {
      datePickerDate: this.date ? this.date : new Date(),
      firstRenderingComplete: false,
    };
  },
  computed: {
    ...mapState('fahrdienst', ['isLoaded', 'fahrdienstDuties', 'fahrdienstDutiesById', 'files', 'filesById', 'unreadCountsByInstance']),
    moduleType: () => index.moduleType,
    moduleBackendId: () => index.api,
    moduleConfig() {
      return this.getModuleConfig(index.moduleType, this.$route.params.instance);
    },
    hideDocumentDownload() {
      return this.moduleConfig.hideDocumentDownload ? true : false;
    },
    hideDocumentShare() {
      return this.moduleConfig.hideDocumentShare ? true : false;
    },
    duties() {
      return this.fahrdienstDuties;
    },
    duty() {
      return this.$route.params.dutyId ? this.fahrdienstDutiesById[this.$route.params.dutyId] : null;
    },
    date() {
      if (this.$route.params.dateYYYYMMDD) {
        let date = dateUtils.parseYYYYMMDD(this.$route.params.dateYYYYMMDD);
        console.debug('computed date from route', this.$route.params.dateYYYYMMDD, date);
        return date;
      }
      return new Date();
    },

    displayedDocument() {
      return this.$route.params.documentId ? this.filesById[this.$route.params.documentId] : null;
    },
    // duty files read state is not taken into account for counter badge
    hasReadFeature() {
      return this.displayedDocument && !this.fahrdienstDutyTypeIds.includes(this.displayedDocument.typeIdFk);
    },
    selectedItemTitle() {
      let title = '';
      if (this.displayedDocument) {
        title += `Dienst ${this.displayedDocument.title}`;
      }
      let date = this.date;
      let duty = this.duty;
      if (date) {
        title += `${title ? ', ' : ''} ${dateUtils.formatWithMonthNameAndShortWeekday(date)}`;
      }
      if (duty) {
        title += title ? ', ' : '' + `${duty.title}`;
      }
      return title;
    },

    /**
     * Calculates distinct and sorted duties with all duties referenced in fahrdienst_file.dienst without
     * applying any of the rules defining if a duty is valid at a given date/day.
     * @returns {*[]}
     */
    dutiesCollectedFromFilesNoDateRulesApplied() {
      let dutiesByName = dataUtils.buildIdMap(
        this.duties.filter((d) => d.inst === this.instance),
        'title'
      );

      // Create map with distinct dutyNames
      let distinctDutiesByName = {};
      this.instanceFiles
        .filter((f) => f.inst === this.instance)
        .forEach((f) => {
          distinctDutiesByName[f.dienst] = f.dienst;
        });
      console.debug('dutiesByName', JSON.stringify(distinctDutiesByName, null, 2));

      // Lookup duty objects (from db table fahrdienst_attr) and sort them
      return Object.keys(distinctDutiesByName)
        .map((duty) => {
          let title = distinctDutiesByName[duty];
          return dutiesByName[title];
        })
        .sort(fahrdienstUtil.dutyComparator);
    },

    dutiesAtSelectedDate() {
      if (this.isLoaded && this.fahrdienstDutyTypeIds.length > 0) {
        let rawSelection = false;
        if (rawSelection) {
          return this.dutiesCollectedFromFilesNoDateRulesApplied;
        }
        console.debug('calculate dutiesAtSelectedDate with his.fahrdienstDutie', this.fahrdienstDuties);
        let dutiesAtSelectedDate = fahrdienstUtil.getDutiesAtSelectedDate({
          date: this.datePickerDate,
          fahrdienstDuties: this.fahrdienstDuties,
          dutyFilesTypeIdFk: this.fahrdienstDutyTypeIds,
          files: this.instanceFiles,
          instance: this.instance,
          verkehrsPeriodenKalender: DB.verkehrsPeriodenKalender,
          additionalFahrdienstDays: DB.additionalFahrdienstDays,
          cancelledFahrdienstDays: DB.cancelledFahrdienstDays,
          filterByDate: this.moduleConfig.fahrdienstDutyListSelectedDateOnly,
        });

        return dutiesAtSelectedDate;
      }
      return [];
    },

    documentUrl() {
      return this.displayedDocument ? this.constructPdfJsFileUrl(this.moduleBackendId, this.displayedDocument, 'filename') : null;
    },

    isToAcknowledge() {
      return acknowledgeService.isToAcknowledge(this.displayedDocument);
    },

    color() {
      return this.theme.appBar.other.color;
    },
  },
  methods: {
    onDateDutySelectionCompleted({ date, duty }) {
      // console.debug('onDateDutySelectionCompleted changed', JSON.stringify({date, duty}, null, 2));
      let { instance, dutyId, dateYYYYMMDD, documentId } = this.$route.params;
      if (duty && date) {
        let selectedDateYYYYMMDD = dateUtils.formatDateAsYYYYMMDD(date);

        if (duty.inst === instance && duty.id === dutyId && selectedDateYYYYMMDD === dateYYYYMMDD) {
          console.debug('same selection as before. Ignore');
        } else {
          console.debug('change route to new date', selectedDateYYYYMMDD);

          this.$router.push({
            name: ROUTE_FAHRDIENST_DUTY,
            params: { instance: duty.inst, dutyId: duty.id, dateYYYYMMDD: selectedDateYYYYMMDD },
          });
          // }
        }
      } else if (date && !duty) {
        let dateAsYYYYMMDD = dateUtils.formatDateAsYYYYMMDD(date);

        if (this.$route.name === ROUTE_FAHRDIENST_DAY && dateYYYYMMDD !== dateAsYYYYMMDD) {
          console.debug('Change route to new date', dateAsYYYYMMDD);
          this.$router.push({
            name: ROUTE_FAHRDIENST_DAY,
            params: { instance, dateYYYYMMDD: dateAsYYYYMMDD },
          });
        } else {
          console.debug('Skip navigation because it equals current route');
        }
      }
    },
  },
  watch: {
    $route(newValue) {
      console.debug('route params', newValue.params);
      let { instance, dutyId, dateYYYYMMDD, documentId } = this.$route.params;
      this.datePickerDate = dateUtils.parseYYYYMMDD(dateYYYYMMDD);
    },

    date(newValue) {
      console.debug('set datePickerDate according to the date calculated from route', newValue);
      this.datePickerDate = newValue;
    },

    datePickerDate(newValue) {
      console.debug('datePickerDate change', newValue);
      this.onDateDutySelectionCompleted({ date: newValue, duty: this.duty });
    },
  },
};
</script>
